export class ValidUser {
    constructor(
         public valid: boolean,
         public message: string
    ) { }
// eslint-disable-next-line eol-last
}